import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { Tagline, Wordmark } from './Wordmark';

/** Sign-in, sign-up and email-link pages: one narrow column, nothing else. */
export function AuthLayout({ title, description, children, footer }: { title: string; description?: ReactNode; children: ReactNode; footer?: ReactNode }) {
  return (
    <div className="flex min-h-dvh flex-col px-4 py-8 sm:py-14">
      <div className="mx-auto w-full max-w-[400px]">
        <Link to="/" className="inline-block" aria-label="Hoopify home">
          <Wordmark size={40} />
        </Link>
        <Tagline size={12} className="mt-3 hidden sm:flex" />
        <h1 className="mt-12 text-[24px] leading-tight sm:text-[28px]">{title}</h1>
        {description && <p className="mt-2 text-muted">{description}</p>}
        <div className="mt-7">{children}</div>
        {footer && <div className="mt-8 border-t border-line pt-5 text-[14px] text-muted">{footer}</div>}
      </div>
    </div>
  );
}
